module.exports = __webpack_public_path__ + "static/img/28.8df0254e.png";